import React, { useState, useEffect } from 'react';
import { fetchWithAuth } from '../../utils/fetchWithAuth';
import { useUser } from '../../context/UserContext';
import Modal from './Modal';
import Button from './Button';
import { useForm } from 'react-hook-form';

const QRCodeBox = ({ objectId, type, qrCodePath, className = 'w-16 h-16', withActions = false }) => {
    const [qrImage, setQrImage] = useState(qrCodePath);
    const [isLoading, setIsLoading] = useState(!qrCodePath);
    const [error, setError] = useState(null);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isCreateModalOpen, setIsCreateModalOpen] = useState(false);
    const { logout } = useUser();
    const { register, handleSubmit, reset } = useForm();

    useEffect(() => {
        if ((!qrCodePath || qrCodePath === '') && objectId && type) {
            fetchQRCode();
        } else {
            setIsLoading(false);
        }
    }, [objectId, type, qrCodePath]);

    const fetchQRCode = async () => {
        try {
            setIsLoading(true);
            const response = await fetchWithAuth(
                `${process.env.REACT_APP_API_URL}/qr/by-object/${objectId}?type=${type}`,
                {},
                logout
            );
            const data = await response.json();
            setQrImage(data.qrCodePath);
        } catch (err) {
            setError('QR код не найден');
        } finally {
            setIsLoading(false);
        }
    };

    const handleCreateQR = async (data) => {
        try {
            setIsLoading(true);
		  
            const response = await fetchWithAuth(
                `${process.env.REACT_APP_API_URL}/qr/generate`,
                {
                    method: 'POST',
                    body: JSON.stringify({
                        type,
                        objectId,
                        typeModel: type?.charAt(0).toUpperCase() + type?.slice(1),
                        description: data.description || `QR код для ${type}`
                    }),
                },
                logout
            );
            const result = await response.json();
            setQrImage(result.qrCodePath);
            setError(null);
            setIsCreateModalOpen(false);
            reset();
        } catch (err) {
            setError('Ошибка при создании QR кода');
        } finally {
            setIsLoading(false);
        }
    };

    const handlePrint = () => {
        const printWindow = window.open('', '_blank');
        printWindow.document.write(`
            <html>
                <head>
                    <title>Печать QR кода</title>
                    <style>
                        body { display: flex; justify-content: center; align-items: center; height: 100vh; margin: 0; }
                        img { max-width: 300px; max-height: 300px; }
                    </style>
                    <script>
                        function handleLoad() {
                            setTimeout(() => {
                                window.print();
                                window.close();
                            }, 500);
                        }
                    </script>
                </head>
                <body onload="handleLoad()">
                    <img src="${process.env.REACT_APP_API_URL}${qrImage}" alt="QR код" />
                </body>
            </html>
        `);
        printWindow.document.close();
    };

    const handleDownload = async () => {
        try {
            // Загружаем изображение как blob
            const response = await fetch(`${process.env.REACT_APP_API_URL}${qrImage}`);
            const blob = await response.blob();
            
            // Создаем URL объект для blob
            const blobUrl = window.URL.createObjectURL(blob);
            
            // Создаем ссылку для скачивания
            const link = document.createElement('a');
            link.href = blobUrl;
            link.download = `qr-${type}-${objectId}.png`;
            
            // Добавляем ссылку в DOM, кликаем и удаляем
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            
            // Освобождаем blob URL
            setTimeout(() => {
                window.URL.revokeObjectURL(blobUrl);
            }, 100);
        } catch (error) {
            console.error('Ошибка при скачивании QR кода:', error);
            setError('Ошибка при скачивании QR кода');
        }
    };

	return (
		<>
		  {isLoading ? (
			<div className="flex items-center justify-center">Загрузка...</div>
		  ) : error ? (
			<div className="flex flex-col items-center justify-center gap-2">
			  <div className="text-red-500">{error}</div>
			  <Button
				onClick={() => setIsCreateModalOpen(true)}
				variant="primary"
				size="sm"
			  >
				Создать QR код
			  </Button>
			</div>
		  ) : !qrImage ? (
			<div className="flex flex-col items-center justify-center gap-2">
			  <div className="text-gray-500">QR код не найден</div>
			  <Button
				onClick={() => setIsCreateModalOpen(true)}
				variant="primary"
				size="sm"
			  >
				Создать QR код
			  </Button>
			</div>
		  ) : (
			<div className="relative w-max">
			  <img
				src={`${process.env.REACT_APP_API_URL}${qrImage}`}
				alt="QR код"
				className={className}
				onClick={() => withActions && setIsModalOpen(true)}
			  />
	  
			  {/* {withActions && (
				<div className="flex justify-center gap-2 mt-2">
				  <Button variant="outline" size="sm" onClick={() => setIsModalOpen(true)}>
                    <span className="mr-1">🔍</span> Просмотр
                  </Button>
				  <Button variant="outline" size="sm" onClick={handlePrint}>
                    <span className="mr-1">🖨</span> Печать
                  </Button>
				  <Button variant="outline" size="sm" onClick={handleDownload}>
                    <span className="mr-1">📥</span> Скачать
                  </Button>
				</div>
			  )} */}
			</div>
		  )}
	  
		  {/* Модалки ВСЕГДА рендерятся, независимо от состояния QR */}
		  <Modal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)}>
			<img
			  src={`${process.env.REACT_APP_API_URL}${qrImage}`}
			  alt="QR код"
			  className="w-1/2 h-1/2 object-contain mx-auto"
			/>
			<div className="flex flex-col justify-center gap-3 mt-2">
				  <Button variant="ghost" size="sm" onClick={handlePrint}>
                    <span className="mr-1">🖨</span> Печать
                  </Button>
				  <Button variant="ghost" size="sm" onClick={handleDownload}>
                    <span className="mr-1">📥</span> Скачать
                  </Button>
				</div>
		  </Modal>
	  
		  <Modal
			isOpen={isCreateModalOpen}
			onClose={() => setIsCreateModalOpen(false)}
			title="Создание QR кода"
		  >
			<div className="p-4">
			  <form onSubmit={handleSubmit(handleCreateQR)} className="space-y-4">
				<div>
				  <label className="block text-sm font-medium text-gray-300">
					Описание
				  </label>
				  <textarea
					{...register('description')}
					className="mt-1 block w-full rounded-md border-gray-700 bg-[#1E1E1E] text-white shadow-sm focus:border-blue-500 focus:ring-blue-500"
					rows={3}
					placeholder="Введите описание QR кода"
				  />
				</div>
				<div className="flex justify-end">
				  <Button type="submit" variant="primary">
					Создать
				  </Button>
				</div>
			  </form>
			</div>
		  </Modal>
		</>
	  );
	  
};


export default QRCodeBox;